define('services/embeddingService',[
    'jquery',
    'lib/lodash4',
    'lib/knockout',
    'config',
    'services/loggingService',
    'services/serverLogger',
    'services/activeRequestTracker',
    'util/PubSub'
], function (
    $,
    _,
    ko,
    config,
    loggingService,
    serverLogger,
    requestTracker,
    PubSub
) {
    'use strict';

    var initialized = false;
    var payloadQueue = [];

    function flushQueue() {
        _.each(payloadQueue, sendPayload);
    }

    function parseUrl(location) {
        var link = document.createElement("a");
        link.href = location;
        return link;
    }

    function getMessageLocation(newLocation) {
        if (isFullUrl(newLocation)) {
            var newUrl = parseUrl(newLocation);
            var currentUrl = parseUrl(window.location.href);
            if (isSamePage(currentUrl, newUrl)) {
                return newUrl.hash;
            }
        }

        return newLocation;
    }

    function isFullUrl(location) {
        return /^http/.test(location);
    }

    function isSamePage(url1, url2) {
        return url1.protocol === url2.protocol &&
            url1.host === url2.host &&
            url1.pathname == url2.pathname &&
            url1.search === url2.search;
    }

    function queuePayload(payload) {
        payloadQueue.push(payload);
    }

    function sendMessage(type, data, options) {
        options = options || {};
        var message = {
            type: type,
            data: data,
            options: options
        };

        if (initialized || message.type == 'initialized') {
            sendPayload(message);
        } else {
            queuePayload(message);
        }
    }

    var messageHandlers = {
        publish: function (data) {
            var topicName = data.topic;
            var topicData = data.data;
            PubSub.Topic(topicName).publish(topicData);
        },
        logout: function () {
            requestTracker.isLoggedIn(false);
            requestTracker.isOAuthSessionExpired(false);
            serverLogger.isLoggedIn(false);
        }
    };

    function triggerMessageAction (type, data) {
        if (messageHandlers[type]) {
            loggingService.trace('Handling message type', type, data);
            messageHandlers[type].call(null, data);
        } else {
            loggingService.warn('Unknown message type', type, data);
        }
    }

    function handleMessageEvent (event) {
        var messageEvent = event.originalEvent;
        var messageData = messageEvent.data;
        if (messageEvent.source === window.parent && messageData.type) {
            triggerMessageAction(messageData.type.toLowerCase(), messageData.data);
        }
    }

    function sendPayload(payload) {
        loggingService.trace('Sending message to', config.embeddingOrigin, payload);
        window.parent.postMessage(payload, config.embeddingOrigin);
    }

    function setInitialized() {
        initialized = true;
        flushQueue();
    }

    var embeddingService = {

        currentBreadcrumbArray: ko.observableArray(),

        invalidateSession: function () {
            sendMessage('invalidatesession');
        },

        requestLogout: function () {
            sendMessage('logout');
        },

        requestNavigation: function (newLocation, options) {
            options = options || {};
            var location = getMessageLocation(newLocation);
            sendMessage('navigation', location, options);
        },

        requestRedirect: function (newLocation) {
            var location = getMessageLocation(newLocation);
            sendMessage('redirect', location);
        },

        notifyInitialized: function () {
            sendMessage('initialized');
            setInitialized();
        },

        sendToastNotification: function (toast) {
            sendMessage('toast', toast);
        },

        sendDocumentFax: function(documentData) {
            sendMessage('documentFax', JSON.stringify(documentData));
        },

        registerNavigation: function (navTree) {
            sendMessage('registernav', navTree);
        },

        notifyInteracting: function (interacting) {
            sendMessage('interaction', interacting);
        },

        notifyNewBreadCrumbs: function (breadcrumb) {
            if (!_.isEqual(breadcrumb, this.currentBreadcrumbArray())) {
                this.currentBreadcrumbArray(breadcrumb);
                sendMessage('breadcrumb', breadcrumb);
            }
        },

        notifyACDInteractions: function (count) {
            sendMessage('acd', count);
        },

        notifyIsNotResponding: function(isNotResponding) {
            sendMessage('responding', !isNotResponding);
        },

        showPhoneSelection: function () {
            sendMessage('phone');
        },

        listenForMessages: function() {
            $(window).on('message', _.bind(handleMessageEvent, this));
        },

        notifyBackNavigation: function () {
            sendMessage('back');
        },

        notifyHelpURL: function (helpURL) {
            sendMessage('helpurl', helpURL);
        }

    };

    // Request login if OAuth Session is invalid
    ko.computed(function() {
        if (requestTracker.isOAuthSessionExpired()) {
            embeddingService.requestLogout();
        }
    });

    embeddingService.listenForMessages();

    return embeddingService;

});

